import { render } from "./AgeVerticalBarChart.vue?vue&type=template&id=1daa966e"
import script from "./AgeVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./AgeVerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__